import { render, staticRenderFns } from "./AppBackground.vue?vue&type=template&id=31c2ba60&scoped=true&"
import script from "./AppBackground.vue?vue&type=script&lang=js&"
export * from "./AppBackground.vue?vue&type=script&lang=js&"
import style0 from "./AppBackground.vue?vue&type=style&index=0&id=31c2ba60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2ba60",
  null
  
)

export default component.exports